const alertActions = {
    add: 'ADD_ALERT_MESSAGE',
    remove: 'REMOVE_ALERT_MESSAGE'
}

export default alertActions;